import {PropsWithChildren} from "react";

import {Accordion} from "@/components/accordion/Accordion.tsx";
import {Alert} from "@/components/alert/Alert.tsx";

interface SetupInfoProps extends PropsWithChildren {
  metricsWarning?: boolean;
}

export const SetupInfo = ({metricsWarning = false, children}: SetupInfoProps) => (
  <Accordion variant={"formAccordion"}>
    <Accordion.Item key={"setup"} eventKey={"setup"}>
      <Accordion.Header className={"pulseTextBodyBold"}>Setup Info</Accordion.Header>
      <Accordion.Body>
        {children}
        {metricsWarning && (
          <div className={"p-2 pb-0"}>
            <Alert variant={"maintenance"}>Metric data may take up to 30 minutes to initially appear.</Alert>
          </div>
        )}
      </Accordion.Body>
    </Accordion.Item>
  </Accordion>
);
